export default function constructDataElement(value, stroke, label, isPartOfMainPercentage) {
  return {
    value,
    stroke,
    label,
    isPartOfMainPercentage
  };
}
